import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class AppGlobals {
    localStorageKeys  = {
        currentUser: "currentUser",
        timer: "timer",
        sessionStorage: "sessionStorage",
        sessionRefresh: "sessionRefresh"
    };

    alertMessageTypes = {
        success: "success",
        warning: "warning",
        error: "error",
        info: "info"
    };

    systemDefaults ={
        daysBeforePermitToStayExpiryForRenewal: "DAYSPTSRNWL"
    }

    private pageTitleSubject = new BehaviorSubject<string>("");

    pageTitle = this.pageTitleSubject.asObservable();

    get pageTitleValue(): string {
        return this.pageTitleSubject.value;
    }

    set pageTitleValue(value: string) {
        this.pageTitleSubject.next(value);
    }
}